import React from "react";

function IconCalendar() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.25a.75.75 0 01.75.75v.25H17c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0117 17.75H3A1.75 1.75 0 011.25 16V4c0-.966.784-1.75 1.75-1.75h1.25V2a.75.75 0 011.5 0v.25h8.5V2a.75.75 0 01.75-.75zm-.75 2.5h-8.5V4a.75.75 0 01-1.5 0v-.25H3a.25.25 0 00-.25.25v12c0 .138.112.25.25.25h14a.25.25 0 00.25-.25V4a.25.25 0 00-.25-.25h-1.25V4a.75.75 0 01-1.5 0v-.25zm-.672 3.797a.75.75 0 010 1.061l-3.97 3.97a.75.75 0 01-1.06 0L6.47 10.5a.75.75 0 011.06-1.06l1.548 1.547 3.439-3.44a.75.75 0 011.06 0z"
      />
    </svg>
  );
}

export default IconCalendar;
